import { createAuthClient } from 'better-auth/react';

import { authApiBasePath } from '@calorie-tracker/auth';

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: authApiBasePath,
});
